
// Session configuration
export const SESSION_EXPIRESIN = process.env.REACT_APP_SESSION_EXPIRESIN;

// Limits
export const limit = 500;
export const statsBarLimit = 2250;

// Default values
export const default_userAvatar = process.env.REACT_APP_DEFAULT_USER_AVATAR;
export const defaultVLLogo = process.env.REACT_APP_DEFAULT_VL_LOGO;
export const defaultEHouseLogo = process.env.REACT_APP_DEFAULT_EHOUSE_LOGO;

let configCache = null;
let configRegionCache = null;

export const createConfig = async () => {
    if (configCache) {
        return configCache;
    }

    const awsEnvironment = process.env.REACT_APP_ENV;
    configCache = {
        isProd: awsEnvironment === "PROD"
    };
    return configCache;
};

export const createConfigRegion = async () => {
    if (configRegionCache) {
        return configRegionCache;
    }

    const awsRegion = process.env.REACT_APP_DEVELOPMENT_REGION;

    configRegionCache = {
        awsRegion: awsRegion
    };

    return configRegionCache;
};

// Endpoints configuration
export const prodEndPoints = {
    'us-east-1': {
        apiurl: process.env.REACT_APP_PROD_US_EAST_1_API_URL,
        bucketurl: process.env.REACT_APP_PROD_US_EAST_1_BUCKET_URL,
        bucketname: process.env.REACT_APP_PROD_US_EAST_1_BUCKET_NAME
    },
    'ca-central-1': {
        apiurl: process.env.REACT_APP_PROD_CA_CENTRAL_1_API_URL,
        bucketurl: process.env.REACT_APP_PROD_CA_CENTRAL_1_BUCKET_URL,
        bucketname: process.env.REACT_APP_PROD_CA_CENTRAL_1_BUCKET_NAME
    },
    'eu-west-1': {
        apiurl: process.env.REACT_APP_PROD_EU_WEST_1_API_URL,
        bucketurl: process.env.REACT_APP_PROD_EU_WEST_1_BUCKET_URL,
        bucketname: process.env.REACT_APP_PROD_EU_WEST_1_BUCKET_NAME
    }
};

export const devEndPoints = {
    'us-east-1': {
        apiurl: process.env.REACT_APP_DEV_US_EAST_1_API_URL,
        bucketurl: process.env.REACT_APP_DEV_US_EAST_1_BUCKET_URL,
        bucketname: process.env.REACT_APP_DEV_US_EAST_1_BUCKET_NAME
    },
    'ca-central-1': {
        apiurl: process.env.REACT_APP_DEV_CA_CENTRAL_1_API_URL,
        bucketurl: process.env.REACT_APP_DEV_CA_CENTRAL_1_BUCKET_URL,
        bucketname: process.env.REACT_APP_DEV_CA_CENTRAL_1_BUCKET_NAME
    },
    'us-west-2': {
        apiurl: process.env.REACT_APP_DEV_US_WEST_2_API_URL,
        bucketurl: process.env.REACT_APP_DEV_US_WEST_2_BUCKET_URL,
        bucketname: process.env.REACT_APP_DEV_US_WEST_2_BUCKET_NAME
    }
};

// Marketplace IDs
export const marketPlaceID = {
    'Canada': process.env.REACT_APP_MARKETPLACE_ID_CANADA,
    'US': process.env.REACT_APP_MARKETPLACE_ID_US,
    'Mexico': process.env.REACT_APP_MARKETPLACE_ID_MEXICO,
    'Brazil': process.env.REACT_APP_MARKETPLACE_ID_BRAZIL,
    'UK': process.env.REACT_APP_MARKETPLACE_ID_UK
};

// Seller Central URLs
export const sellerCentralURL = {
    'Canada': process.env.REACT_APP_SELLER_CENTRAL_URL_CANADA,
    'US': process.env.REACT_APP_SELLER_CENTRAL_URL_US,
    'Mexico': process.env.REACT_APP_SELLER_CENTRAL_URL_MEXICO,
    'Brazil': process.env.REACT_APP_SELLER_CENTRAL_URL_BRAZIL,
    'UK': process.env.REACT_APP_SELLER_CENTRAL_URL_UK
};

// Vendor Central URLs
export const vendorCentralURL = {
    'Canada': process.env.REACT_APP_VENDOR_CENTRAL_URL_CANADA,
    'US': process.env.REACT_APP_VENDOR_CENTRAL_URL_US,
    'Mexico': process.env.REACT_APP_VENDOR_CENTRAL_URL_MEXICO,
    'Brazil': process.env.REACT_APP_VENDOR_CENTRAL_URL_BRAZIL,
    'UK': process.env.REACT_APP_VENDOR_CENTRAL_URL_UK
};

// Marketplace regions
export const marketplaceRegion = {
    "UK": process.env.REACT_APP_MARKETPLACE_REGION_UK,
    "Canada": process.env.REACT_APP_MARKETPLACE_REGION_CANADA
};

// Miscellaneous configurations
export const omni_trust_center = process.env.REACT_APP_OMNI_TRUST_CENTER;
export const vlomni_logo_connectors = process.env.REACT_APP_VLOMNI_LOGO_CONNECTORS;